var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c("header-tabs", { attrs: { active: _vm.$route.path } }),
      _vm._v(" "),
      _c("el-row", {}, [
        _c(
          "div",
          {
            staticStyle: {
              width: "80%",
              margin: "0 auto",
              "margin-top": "20px",
              "margin-bottom": "20px"
            }
          },
          [
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "demo-ruleForm",
                attrs: { model: _vm.form, "label-width": "160px" }
              },
              [
                _c("div", { staticClass: "border_space" }, [
                  _c("p", [_vm._v("拣货设置")]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { height: "51px", "line-height": "51px" } },
                    [
                      _vm._v("\n            异常提示:大于等于"),
                      _c("el-input", {
                        staticStyle: { width: "20%" },
                        attrs: { prop: "yc_range" },
                        model: {
                          value: _vm.form.yc_range,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "yc_range", $$v)
                          },
                          expression: "form.yc_range"
                        }
                      }),
                      _vm._v("\n            %或者大于等于"),
                      _c("el-input", {
                        staticStyle: { width: "20%" },
                        attrs: { type: "number", prop: "yc_num" },
                        model: {
                          value: _vm.form.yc_num,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "yc_num", $$v)
                          },
                          expression: "form.yc_num"
                        }
                      }),
                      _vm._v("\n            件商品有异常时，提示"),
                      _c("el-input", {
                        staticStyle: { width: "20%" },
                        attrs: { type: "", prop: "alert_txt" },
                        model: {
                          value: _vm.form.alert_txt,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "alert_txt", $$v)
                          },
                          expression: "form.alert_txt"
                        }
                      })
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "border_space" }, [
                  _c("p", [_vm._v("囤货上架配置")]),
                  _vm._v(" "),
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { height: "51px", "line-height": "51px" } },
                    [
                      _vm._v(
                        "\n            上架时扫描商品数量配置： 扫描商品大于等于\n            "
                      ),
                      _vm._v(" "),
                      _c("el-input", {
                        staticStyle: { width: "20%" },
                        attrs: { prop: "stock_scan_rate" },
                        model: {
                          value: _vm.form.stock_scan_rate,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "stock_scan_rate", $$v)
                          },
                          expression: "form.stock_scan_rate"
                        }
                      }),
                      _vm._v(
                        "\n            %容器内所需上架商品，允许扫描仓位将容器上架。\n          "
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "border_space" },
                  [
                    _c(
                      "el-row",
                      {},
                      [
                        _c(
                          "el-col",
                          {
                            staticStyle: {
                              "padding-top": "31px",
                              "border-right": "2px solid #ccc"
                            },
                            attrs: { span: 12 }
                          },
                          [
                            _c("p", [_vm._v("拣货任务花名设置")]),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "单个波次:",
                                  prop: "one_wave_picking"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "30%" },
                                  attrs: { type: "" },
                                  model: {
                                    value: _vm.form.one_wave_picking,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "one_wave_picking",
                                        $$v
                                      )
                                    },
                                    expression: "form.one_wave_picking"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "单件汇总:",
                                  prop: "one_wave_picking_summary"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "30%" },
                                  attrs: { type: "" },
                                  model: {
                                    value: _vm.form.one_wave_picking_summary,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "one_wave_picking_summary",
                                        $$v
                                      )
                                    },
                                    expression: "form.one_wave_picking_summary"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "多件多波:",
                                  prop: "many_num_wave_picking"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "30%" },
                                  attrs: { type: "" },
                                  model: {
                                    value: _vm.form.many_num_wave_picking,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "many_num_wave_picking",
                                        $$v
                                      )
                                    },
                                    expression: "form.many_num_wave_picking"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "多件少波:",
                                  prop: "less_num_wave_picking"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "30%" },
                                  attrs: { type: "" },
                                  model: {
                                    value: _vm.form.less_num_wave_picking,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "less_num_wave_picking",
                                        $$v
                                      )
                                    },
                                    expression: "form.less_num_wave_picking"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "质检汇总:",
                                  prop: "quality_summary"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "30%" },
                                  attrs: { type: "" },
                                  model: {
                                    value: _vm.form.quality_summary,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "quality_summary", $$v)
                                    },
                                    expression: "form.quality_summary"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "改标汇总:",
                                  prop: "label_summary"
                                }
                              },
                              [
                                _c("el-input", {
                                  staticStyle: { width: "30%" },
                                  attrs: { type: "" },
                                  model: {
                                    value: _vm.form.label_summary,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "label_summary", $$v)
                                    },
                                    expression: "form.label_summary"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          {
                            staticStyle: { "padding-top": "31px" },
                            attrs: { span: 6 }
                          },
                          [
                            _c(
                              "p",
                              { staticStyle: { "margin-left": "15px" } },
                              [_vm._v("分播设置")]
                            ),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              {
                                staticStyle: { "margin-left": "15px" },
                                attrs: {
                                  label: "波次粗分单格口波次数:",
                                  prop: "rough_wave_num"
                                }
                              },
                              [
                                _c("el-input-number", {
                                  attrs: { min: 2, type: "" },
                                  model: {
                                    value: _vm.form.rough_wave_num,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "rough_wave_num", $$v)
                                    },
                                    expression: "form.rough_wave_num"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c("div", { staticClass: "picking-task-path" }, [
                              _c(
                                "p",
                                { staticStyle: { "margin-left": "15px" } },
                                [_vm._v("pda拣货任务路径配置")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "picking-task-path-wrap" },
                                [
                                  _c(
                                    "Draggable",
                                    {
                                      staticClass: "picking-task-path-list",
                                      attrs: { group: "people" },
                                      on: {
                                        start: function($event) {
                                          _vm.drag = true
                                        },
                                        end: function($event) {
                                          _vm.drag = false
                                        }
                                      },
                                      model: {
                                        value: _vm.pdaPickingTaskPaths,
                                        callback: function($$v) {
                                          _vm.pdaPickingTaskPaths = $$v
                                        },
                                        expression: "pdaPickingTaskPaths"
                                      }
                                    },
                                    _vm._l(_vm.pdaPickingTaskPaths, function(
                                      name
                                    ) {
                                      return _c(
                                        "el-button",
                                        { key: name, staticClass: "drag-item" },
                                        [
                                          _vm._v(
                                            "\n                      " +
                                              _vm._s(name) +
                                              "\n                    "
                                          )
                                        ]
                                      )
                                    }),
                                    1
                                  )
                                ],
                                1
                              )
                            ])
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "submit-wrap" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "on-submit",
                    attrs: { type: "primary" },
                    on: { click: _vm.onSubmit }
                  },
                  [_vm._v("\n          保存\n        ")]
                )
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6df8e0ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6df8e0ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/wavepicking/PdaSetting.vue
// module id = null
// module chunks = 